import { z } from 'zod';
import { ClaimEscalationRule } from '../prisma/enums';

/**
 * The stored shape of `fleet_escalation_configuration` (CUR-618).
 *
 * Lives in shared because both ends must agree exactly: the settings form writes
 * this JSON and the server refuses to escalate on anything that fails to parse.
 * A second copy of these bounds on the client would let the UI save a value the
 * evaluator then rejects — the config would read as configured while silently
 * escalating nothing.
 */

/** One minute, so a demo can breach inside a meeting. */
export const MIN_ESCALATION_THRESHOLD_MINUTES = 1;
/** Ninety days — beyond that an "exception" notice is archaeology. */
export const MAX_ESCALATION_THRESHOLD_MINUTES = 60 * 24 * 90;

export const claimEscalationRuleSettingSchema = z.object({
    isEnabled: z.boolean(),
    thresholdMinutes: z.number().int().min(MIN_ESCALATION_THRESHOLD_MINUTES).max(MAX_ESCALATION_THRESHOLD_MINUTES),
});

export const fleetEscalationConfigurationSchema = z
    .object({
        isEnabled: z.boolean(),
        onlyClaimsCreatedAfter: z.iso.datetime({ offset: true }).nullable(),
        rules: z.object({
            [ClaimEscalationRule.REPAIRER_NOT_ASSIGNED]: claimEscalationRuleSettingSchema,
            [ClaimEscalationRule.QUOTE_NOT_RECEIVED]: claimEscalationRuleSettingSchema,
            [ClaimEscalationRule.QUOTE_NOT_ASSESSED]: claimEscalationRuleSettingSchema,
        }),
    })
    .refine((value) => !value.isEnabled || value.onlyClaimsCreatedAfter !== null, {
        path: ['onlyClaimsCreatedAfter'],
        message: 'A claim creation cutoff is required while escalation emails are enabled.',
    });
